import { Map } from './Map';

export const App = () => (
  <div style={{ position: 'fixed', inset: 0 }}>
    <Map />
  </div>
);
